export default "__VITE_ASSET__df9d8dd5__"